import { apolloClient } from "@/plugins/vue-apollo.js";

const createUnitType = (_variables) => {
  // , limit, skip
  let responseFromApi;
  let variables = _variables;
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/property/api/mutations/unitType/create_unit_type.graphql"),
      variables: variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/property/api/queries/unitType/unit_type_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ''
            }
          }
        };
        let allUnitType = store.readQuery(query);
        allUnitType.getUnitTypes.unitTypes.unshift(data.createUnitType); //push to top
        store.writeQuery({
          ...query,
            data: allUnitType,
        });
      }
    })
    .catch(error => {
      return error;
    });
  return responseFromApi;
};
export { createUnitType };
